module.exports = __webpack_public_path__ + "static/media/9DESA2.c836f6ec.jpg";